
  <p (click)="closePolicyDialog()"><mat-icon>close</mat-icon></p>
  <!-- <iframe class="policy-iframe" src="../../../assets/RAIN-INTERNATIONAL-CUSTOMER-RETURN-POLICY.pdf#view=Fit&toolbar=0&statusbar=0&messages=0&navpanes=0&scrollbar=0&zoom=50" width="100%" height="auto" frameborder="0"></iframe> -->
    <img src="../../../assets/policy.jpg" alt="Return Policy" ondblclick="window.open('../../../assets/policy.jpg', '_blank');">

